import React from 'react';
import { Link } from 'react-router-dom';
import { FaQuestionCircle, FaHeadset } from 'react-icons/fa';
import './FloatingHelpButton.css';

const FloatingHelpButton = () => {
  return (
    <Link to="/SupportForm" className="floating-help-btn" title="Help & Support">
      <FaHeadset size={24} />
    </Link>
  );
};

export default FloatingHelpButton;

